import React from 'react';
import {
  SocialMediaWrapper,
  StickyArticleHeaderWrapper,
} from './styles/StickyArticleHeader.styles';
import RichText from '../pageBuilder/Elements/RichText';
import SectionElementSocialMedia from './SectionElementSocialMedia';
import { css } from 'styled-components';
import { Block } from '@legacy-vfuk/core-block';
import { StickyArticleHeaderProps } from './types/StickyArticleHeader.types';
import CtaButtonRow from '../pageBuilder/Elements/CtaButtons/CtaButtonRow';

const StickyArticleHeader = ({
  contentfulSiteConfig,
  seoTitle,
  contentfulConfigArticlePages,
}: StickyArticleHeaderProps) => {
  if(!contentfulConfigArticlePages?.stickyHeader) {
    return null;
  }

  return (
    <StickyArticleHeaderWrapper id="sticky-article-header">
      <Block appearance="secondary" paddingLevel={0}>
        {contentfulConfigArticlePages.stickyHeader.content.map(item => {
          switch (item.__typename) {
            case 'ContentfulSectionElementRichText':
              return (
                <RichText
                  {...item}
                  key={item.id}
                />
              );
            case 'ContentfulSectionElementCtaButton':
              return <CtaButtonRow key={item.id} buttons={[{ ...item }]} />;
            default:
              return null;
          }
        })}

        <SocialMediaWrapper>
          <SectionElementSocialMedia
            css={css``}
            socialMediaButtons={contentfulSiteConfig.sharingsocialMediaButtons}
            socialMediaButtonsLabel={
              contentfulConfigArticlePages.stickyHeader.socialLinksText
            }
            seoTitle={seoTitle}
          />
        </SocialMediaWrapper>
      </Block>
    </StickyArticleHeaderWrapper>
  );
};

export default StickyArticleHeader;
